import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';


function LotSearch() {
  const [attributes, setAttributes] = useState('All');
  const [attributeValues, setAttributeValues] = useState('All');
  const [components, setComponents] = useState('All');
  const [procedure, setProcedure] = useState('All');
  const [serial, setSerial] = useState('');
  const [lot, setLot] = useState('');
  const [format, setFormat] = useState('On Screen');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'attributes':
        setAttributes(value);
        break;
      case 'attributeValues':
        setAttributeValues(value);
        break;
      case 'components':
        setComponents(value);
        break;
      case 'procedure':
        setProcedure(value);
        break;
      case 'format':
        setFormat(value);
        break;
      case 'lot':
        setLot(value);
        break;
      case 'serial':
        setSerial(value);
        break;
      default:
        break;
    }
  };

  return (
    <div className="container mt-5" >
      <div className="row justify-content-left">
        <div className="col-md-6">
          <h2 className="text-left mb-4" style={{ color: 'black' }}>Parameters</h2>
          <form className="p-4 border rounded" style={{ borderTop: '5px solid #1e1bc7' }}>
            <div className="form-group">
              <label htmlFor="procedure">Procedure *</label>
              <select
                name="procedure"
                value={procedure}
                onChange={handleInputChange}
                className="form-control"
              >
                <option value="All">All</option>
                <option value="Procedure A">Procedure A</option>
                <option value="Procedure B">Procedure B</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="attributes">Attributes *</label>
              <select
                name="attributes"
                value={attributes}
                onChange={handleInputChange}
                className="form-control"
              >
                <option value="All">All</option>
                <option value="User A">User A</option>
                <option value="User B">User B</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="attributeValues">Attribute Values *</label>
              <select
                name="attributeValues"
                value={attributeValues}
                onChange={handleInputChange}
                className="form-control"
              >
                <option value="All">All</option>
                <option value="Account 1">Account 1</option>
                <option value="Account 2">Account 2</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="components">Components *</label>
              <select
                name="components"
                value={components}
                onChange={handleInputChange}
                className="form-control"
              >
                <option value="All">All</option>
                <option value="Tag 1">Tag 1</option>
                <option value="Tag 2">Tag 2</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="lot">Lot #</label>
              <input
                type="text"
                name="lot"
                value={lot}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label htmlFor="serial">Serial</label>
              <input
                type="text"
                name="serial"
                value={serial}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label htmlFor="format">Format *</label>
              <select
                name="format"
                value={format}
                onChange={handleInputChange}
                className="form-control"
              >
                <option value="On Screen">On Screen</option>
                <option value="Print">CSV EXCEL</option>
              </select>
            </div>
            <br/>
            <Form.Group as={Row}>
              <Col sm={{ span: 8, offset: 4 }}>
                <Link to="/lotsearchAdd">
                  <Button
                    id="pay-per-task-submit"
                    type="button"
                    variant="primary"
                    className="w-100 mt-2"
                    style={{
                      backgroundColor: '#004aad',
                      borderColor: '#004aad',
                      marginTop: '10px',
                    }}
                  >
                    Run
                  </Button>
                </Link>
              </Col>
            </Form.Group>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LotSearch;
